export default function disabledNextArrow($slider) {
    let $listSlides, $lastSlide, $nextArrow;

    $slider.on('init afterChange', function (event, slick, currentSlide) {
        if (event.type == 'init') {
            $lastSlide = $slider.find('.slick-slide').last();
            $listSlides = $slider.find('.slick-list');
            $nextArrow = $slider.find('.slick-next');
        }

        if ($listSlides.length && isSlideVisiable($listSlides, $lastSlide)) {
            $nextArrow.addClass('slick-disabled');
        }
    });
}

function isSlideVisiable($listSlides, $slide) {
    return (($listSlides.offset().left + $listSlides.width()) - ($slide.offset().left + $slide.width())) > 0;
}